import { render, staticRenderFns } from "./WebShopOptionsAttic.vue?vue&type=template&id=f1cbee8e"
import script from "./WebShopOptionsAttic.vue?vue&type=script&lang=js"
export * from "./WebShopOptionsAttic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports